import { GA4React } from "ga-4-react";
import useSettings from '../settings/useSettings.js';
import React, { useContext, useEffect, useState } from 'react';

//need this context to track the initialisation of the analytics
//doing it with the library's normal methods resulted in a complete crash on browsers with adblock

const AnalyticsContext = React.createContext({});
function useAnalytics() {
    return useContext(AnalyticsContext);
}
function useProvideAnalytics() {
    var settings = useSettings();
    const [code, setCode] = useState(settings.get("Google ID") || "");
    const [analytics, setAnalytics] = useState(null);
    const [initialised, setInitialised] = useState(false);

    useEffect(function () {
        var c = settings.get("Google ID");
        if (c && (code != c || !GA4React.isInitialized())) {
            setCode(c);
            const ga4react = new GA4React(c);
            ga4react.initialize().then((ga4) => {
                setInitialised(true);
                setAnalytics(ga4);
            }, (err) => {
                //console.error(err)
            });
        }
    }, [settings]);

    const tag = (type, category, value) => {
        if (initialised) {
            analytics.gtag(type, category, value)
        }
    };

    return { tag };
}

function ProvideAnalytics({ children }) {
    let analytics = useProvideAnalytics();
    return (
        <AnalyticsContext.Provider value={analytics}>
            {children}
        </AnalyticsContext.Provider>
    );
}

export default useAnalytics;
export { ProvideAnalytics };